import { render } from "./StrategyPill.vue?vue&type=template&id=5cb0169d"
import script from "./StrategyPill.vue?vue&type=script&lang=js"
export * from "./StrategyPill.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__